import { Box, BoxProps } from "@mui/material";
import { ComponentType, forwardRef, PropsWithChildren } from "react";

interface ScrollableProps extends BoxProps {
  scrollRef?: React.RefObject<HTMLDivElement>;
  isLoading: boolean;
  isEmpty: boolean;
  hasAllFetched: boolean;
  children: React.ReactNode;
  loadMoreRef: (node?: Element | null) => void;
  emptyProps?: {
    title: string;
    description: string;
  };
}

const withScrollable = <P extends BoxProps>(
  WrappedComponent: ComponentType<any>,
  LoadingUI: ComponentType<any>,
  EmptyUI: ComponentType<any>,
  LoadMoreComponent: ComponentType<any>,
) => {
  return forwardRef<any, PropsWithChildren<any>>(
    ({ isLoading, isEmpty, hasAllFetched, loadMoreRef, emptyProps, children, ...props }, ref) => {
      return (
        <WrappedComponent {...(props as P)} ref={ref}>
          {isLoading ? <LoadingUI /> : isEmpty ? <EmptyUI {...emptyProps} /> : children}
          {!hasAllFetched && !isLoading && <LoadMoreComponent ref={loadMoreRef} />}
          {hasAllFetched && <Box sx={{ minHeight: "100px" }} />}
        </WrappedComponent>
      );
    },
  );
};

export { withScrollable };
